import { Role } from "@/acl/roles";
import { WINVEST_PRODUCTS_DETAILS } from "@/assets/constants/products/winvest";

export default {
  orgName: "WINVEST ASSET MANAGEMENT",
  logoPath: require("@/assets/images/logo/winvest.png"),
  navBarLogoStyle: "width: 100%; max-height: 100px;",
  allowedLoginMethods: ["Google"],
  products: WINVEST_PRODUCTS_DETAILS,
  hasHoldingData: true,
  possibleRoles: [Role.superAdmin, Role.admin, Role.viewer],
  admin: true,
  help: {
    knowledgeBase: true,
  },
  availableLanguages: ["en", "de"],
  followFeatureActivated: true,
  colorScheme: [
    "#5c5ca2",
    "#9d9dc7",
    "#df6541",
    "#eca38d",
    "#b89150",
    "#d4bd96",
    "#683d44",
    "#a48b8f",
    "#cbb7d0",
    "#e0d4e3",
    "#03475b",
    "#68919d",
  ],
};
